import React from 'react';
import { motion } from 'framer-motion';
import { FaSyncAlt } from 'react-icons/fa';

function joinClasses(...classes) {
  return classes.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
}

export default function RefreshButton({
  children = 'Refresh',
  loading = false,
  onClick,
  className = '',
  title = 'Refresh',
  type = 'button',
  ...rest
}) {
  return (
    <motion.button
      type={type}
      onClick={onClick}
      whileHover={loading ? undefined : { scale: 1.02, y: -1 }}
      whileTap={loading ? undefined : { scale: 0.98 }}
      disabled={loading}
      title={title}
      className={joinClasses(
        'inline-flex items-center justify-center gap-1.5 md:gap-2 rounded-md border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-2 py-1.5 md:px-4 md:py-2 text-[11px] md:text-sm font-semibold text-slate-700 dark:text-gray-200 shadow-sm transition-all duration-200 hover:bg-slate-50 dark:hover:bg-gray-700 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...rest}
    >
      <FaSyncAlt className={loading ? 'animate-spin' : ''} size={13} />
      <span className="hidden md:inline whitespace-nowrap">{children}</span>
    </motion.button>
  );
}
